<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Season of Sacrifice</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<link href="../styles/additional.css" rel="stylesheet" type="text/css"/>
<p class="dedication"><em>For Didi, Rinku, Tinni, and Tom</em></p>
<p class="dedication"><em>How fortunate I am to have you in my life</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?47c7765e